import { stateT } from "../types";
import { IRenderRow } from "./historyTypes";

export const getHistory =
  () =>
  ({ ...state }: stateT) => {
    const historyList: IRenderRow[] = state.history.history;
    return historyList;
  };

export const getHistoryCount =
  () =>
  ({ ...state }: stateT): number => {
    return state.history.historyCount;
  };
